import { useNavigate } from 'react-router-dom'

import Pagination from '@10xLabs/react-web/components/Pagination'
import { PaginationCaption } from 'features/App/components/PaginationCaption'
import { getQueryString } from 'utils/route'

export const TripsPagination = (props: TSFixMe): TSFixMe => {
  const navigate = useNavigate()
  const { page, totalItems, limit, currentItemsCount, filters, departureDateFrom, departureDateTo, getTripsQuery } =
    props

  const setPage = (page: TSFixMe): TSFixMe => {
    const query = {
      page,
      ...getTripsQuery({
        filters,
        departureDateFrom,
        departureDateTo
      })
    }
    navigate(`/trips?${getQueryString(query)}`)
  }

  return (
    <Pagination.Container>
      <Pagination.Caption
        page={page}
        totalItems={totalItems}
        currentItemsCount={currentItemsCount}
        limit={limit}
        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
        getCaptionMessage={(firstItemIndex, lastItemIndex): TSFixMe => (
          <PaginationCaption firstItemIndex={firstItemIndex} lastItemIndex={lastItemIndex} totalItems={totalItems} />
        )}
      />

      <Pagination.Previous page={page} setPage={setPage} />

      <Pagination.Next page={page} totalItems={totalItems} limit={limit} setPage={setPage} />
    </Pagination.Container>
  )
}
